import { z } from "zod";
export const SortByOptionSchema = z.object({
    type: z.string(),
    direction: z.enum(["asc", "desc"]),
    label: z.string(),
    customSort: z.array(z.string()).optional(),
    field: z.string(),
});
export const SortBySchema = z.object({
    label: z.string(),
    options: z.array(SortByOptionSchema),
});
//# sourceMappingURL=sort-by.js.map